/* whiteboxSecret3.ts */

// 混淆后的数据（不是明文）
const _a = [0x59, 0x44, 0x79, 0x61];
const _b = [0x78, 0x06, 0x5e, 0x7e];
const _c = [0x60, 0x33, 0x1a, 0x19];
const _d = [0x28, 0x4f, 0x1b, 0x20];

// 每段使用不同 key
const _k = [0x12, 0x34, 0x56, 0x78];

// 核心“解码”函数（XOR 白盒）
const _x = (v: number, k: number) => (v + 256) ^ k;

const _g = (arr: number[], k: number) =>
  new Uint8Array(arr.map(v => _x(v, k)));

export const _S2 = (): Uint8Array => {
  const p0 = _g(_a, _k[0]);
  const p1 = _g(_b, _k[1]);
  const p2 = _g(_c, _k[2]);
  const p3 = _g(_d, _k[3]);

  const out = new Uint8Array(
    p0.length + p1.length + p2.length + p3.length
  );

  let i = 0;
  out.set(p0, i); i += p0.length;
  out.set(p1, i); i += p1.length;
  out.set(p2, i); i += p2.length;
  out.set(p3, i);

  return out;
};
